import styled from "styled-components";
import { tokens } from "../../public/tokens";

const { colors, globals, effects, typography } = tokens;

/**
 * Wrapper container for video popup content
 */
export const VideoPopupWrapper = styled.div`
  padding: 28px;
  background: ${colors.ui.popover};
  border-radius: ${globals["border-radius"]};
  position: relative;

  box-shadow: ${effects.effects.shadow.default};
`;

/**
 * Title text for video popup
 */
export const VideoTitle = styled.h2`
  margin-bottom: 8px;

  font-size: ${typography.fontSize["3xl-24px"]};
  font-weight: ${typography.fontWeights.bold};
`;

/**
 * Subtitle/description text for video popup
 */
export const VideoSubtitle = styled.p`
  margin-bottom: 20px;
  color: ${colors.text.secondary};
`;

/**
 * Wrapper for responsive video iframe
 */
export const VideoFrameWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${globals["border-radius"]};
  background: ${colors.neutral.black};
  overflow: hidden;
  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;
